<!-- LOADER CONTAINER -->
<div 
    [class]="hideElement ? 'hidden pointer-events-none' : 'pointer-events-auto'"
    class="absolute flex justify-center items-center w-full h-full"
>

    <!-- LOADER -->
    <div 
        #loader
        class="size-28 flex items-center justify-center overflow-hidden cursor-wait rounded-full bg-black/70 backdrop-blur-xs loader-animation">

        <img 
            class="max-h-14 animate-pulse" 
            [src]="logo()" 
            alt="Loader Image"
        >

    </div>

</div>